import { render, staticRenderFns } from "./LeaveCreateStudySetModal.vue?vue&type=template&id=ca192e3e&scoped=true&"
import script from "./LeaveCreateStudySetModal.vue?vue&type=script&lang=js&"
export * from "./LeaveCreateStudySetModal.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCreateStudySetModal.vue?vue&type=style&index=0&id=ca192e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca192e3e",
  null
  
)

export default component.exports